<script>
import eventKinds from '@/modules/events/eventKinds'
import Popper from 'vue3-popper'
import emitter from '@/modules/events/emitter'
import colors from '@/modules/cells/colors'
import moment from 'moment-timezone'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'

export default {
  name: 'RangePlanCommentModal',
  components: { Popper },
  data () {
    return {
      vehicle: null,
      comment: {
        title: '',
        content: '',
        backgroundColor: '#FFFFFF',
        textColor: '#222222',
        mailsList: [],
        mails: '',
        sendNotificationOn: '',
        dateTime: ''
      },
      colors: colors,
      dateFrom: moment().tz('Europe/Warsaw').format('YYYY-MM-DD'),
      dateTo: moment().tz('Europe/Warsaw').add(1, 'days').format('YYYY-MM-DD'),
      processing: false
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  created () {
    emitter.on(eventKinds.rangePlanCommentModalRequested, e => {
      this.vehicle = e.vehicle
    })
  },
  methods: {
    async addComments () {
      const dateFrom = moment(this.dateFrom).tz('Europe/Warsaw')
      const dateTo = moment(this.dateTo).tz('Europe/Warsaw')
      const daysCount = moment.duration(dateTo.diff(dateFrom)).asDays()

      if (daysCount <= 31) {
        this.processing = true
        await this.addComment(0)
        for (let i = 1; i <= daysCount; i++) {
          await this.addComment(i)
        }
        this.processing = false
        emitter.emit('planCommentAdded')
        await Swal.fire('Dodano komentarze', '', 'success')
      } else {
        await Swal.fire('Nie można dodać jednocześnie więcej niż 31 komentarzy', '', 'warning')
      }
    },

    async addComment (i) {
      let date = ''

      if (i === 0) {
        date = moment(this.dateFrom).tz('Europe/Warsaw').format('YYYY-MM-DD')
      } else {
        date = moment(this.dateFrom).tz('Europe/Warsaw').add(i, 'day').format('YYYY-MM-DD')
      }

      const mails = this.comment.mails.split(',')

      const postData = {
        title: this.comment.title,
        content: this.comment.content,
        textColor: this.comment.textColor,
        backgroundColor: this.comment.backgroundColor,
        mailNotificationRecipients: mails,
        sendNotificationOn: this.comment.sendNotificationOn,
        dateTime: date
      }

      try {
        await $axios.post(`Comment/Vehicle/${this.vehicle.id}`, postData)
      } catch (e) {
        await Swal.fire(
          'Nie udało się dodać komentarza',
          `System nie był w stanie dodać komentarza <br> <span class="fw-bold">Kod błędu: ${e.response?.status}</span>`,
          'error'
        )
      }
    }
  }
}
</script>

<template>
  <div class="modal fade" id="rangePlanCommentModal" tabindex="-1" aria-labelledby="rangePlanCommentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rangePlanCommentModalLabel">
            Zaplanuj komentarze
          </h5>
          <button id="select-trailer-parking-modal-close-btn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="vehicle">
          <div v-show="processing">
            Dodaję komentarze...
          </div>
          <form @submit.prevent="addComments">
            <input type="text" class="form-control" v-model="comment.title" placeholder="Tytuł">
            <textarea class="form-control mr-3" v-model="comment.content" placeholder="Treść" style="margin-top: 5px;"></textarea>

            <div class="text-sm mt-2 user-select-none">
              Kolor tekstu etykiety
              <div>
                <div
                  @click="comment.textColor = color"
                  v-for="color in colors"
                  :key="color"
                  role="button"
                  class="mx-1 px-1 d-inline border border-1"
                  :class="{ 'border border-4': comment.textColor === color }"
                  :style="`background-color: ${color};`"
                ></div>
              </div>
            </div>
            <div class="text-sm mt-2 user-select-none" role="button">
              Kolor tła etykiety
              <div>
                <div
                  @click="comment.backgroundColor = color"
                  v-for="color in colors"
                  :key="color"
                  role="button"
                  class="mx-1 px-1 d-inline border border-1"
                  :class="{ 'border border-4': comment.backgroundColor === color }"
                  :style="`background-color: ${color};`"
                ></div>
              </div>
            </div>

            <label class="mt-4" :for="`${comment.id}-meeting-time`">Data od</label>

            <div class="mb-2">
              <input :id="`${comment.id}-date-from`" type="date" class="form-control" v-model="dateFrom">
            </div>

            <label :for="`${comment.id}-meeting-time`">Data do</label>

            <div class="mb-2">
              <input :id="`${comment.id}-date-to`" type="date" class="form-control" v-model="dateTo">
            </div>

            Wyślij przypomnienie:
            <input type="date" class="form-control mb-2" ref="selectedDate" v-model="comment.sendNotificationOn">
            Wypisz maile po przecinku:
            <input type="text" class="form-control" v-model="comment.mails" placeholder="Maile">

            <Popper placement="right">
            <span role="button" class="btn btn-success my-2">
              Wybierz maile z bazy
            </span>
              <template #content>
                <div v-for="m in mailings" :key="m.id" role="button" @click="AddMail (m.value)" style="width: 350px">
                  {{ m.value }} -> {{ m.name }}
                </div>
              </template>
            </Popper>

            <div style="text-align: center;">
              <button class="btn btn-primary" type="submit" :disabled="processing">
                Dodaj komentarz
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
